
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { MyContextProvider } from "./Components/Context";
import { GlobalHandlersProvider } from "./Components/GlobalHandlersContext";
import Loading from "./Components/Loading";

import { Toaster } from 'react-hot-toast';

// Lazy load route components for code splitting
const Home = lazy(() => import("./Components/Home"));
const Products = lazy(() => import("./Components/Products"));
const AboutUs = lazy(() => import("./Components/AboutUs"));
const Terms = lazy(() => import("./Components/Terms"));
const Privacy = lazy(() => import("./Components/Privacy"));
const RefundPolicy = lazy(() => import("./Components/RefundPolicy"));
const ThankYou = lazy(() => import("./Components/ThankYou"));
const Orders = lazy(() => import("./Components/Orders"));
const OrderDetails = lazy(() => import("./Components/OrderDetails"));
const ProductDetail = lazy(() => import("./Components/ProductDetail"));
const Address = lazy(() => import("./Components/Address"));
const SubscriptionForm = lazy(() => import("./Components/SubscriptionForm"));
const Checkout = lazy(() => import("./Components/Checkout"));
const MasterPage = lazy(() => import("./Components/MasterPage"));
const Account = lazy(() => import("./Components/Account"));
const Settings = lazy(() => import("./Components/Settings"));
const PrivateRoute = lazy(() => import("./Components/PrivateRoute"));

// Loading fallback component
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh',
    gap: '1rem',
    flexWrap: 'wrap',
    padding: '2rem'
  }}>
    <Loading />
    <Loading />
    <Loading />
  </div>
);

function App() {
  return (
    <MyContextProvider>
      <GlobalHandlersProvider>
        <BrowserRouter>
          <Toaster position="bottom-center" />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="products" element={<Products />} />
              <Route path="about" element={<AboutUs />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refundpolicies" element={<RefundPolicy />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
              <Route path="/order/:orderId" element={<PrivateRoute><OrderDetails /></PrivateRoute>} />
              <Route path="/master" element={<MasterPage />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/address" element={<PrivateRoute><Address /></PrivateRoute>} />
              <Route path="/subscribe" element={<SubscriptionForm />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
              <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </GlobalHandlersProvider>
    </MyContextProvider>
  );
}

export default App;
